module.exports = __webpack_public_path__ + "img/img13.483e3321.jpg";